// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__7dpcE","footerContent":"style_footerContent__O1Kmo","menus":"style_menus__G0TXL"};